/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2017, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../lib/@waca/baglass/js/baglass/app/ContentView',
	'doT',
	'jquery',
	'../nls/StringResources',
	'text!./templates/genericIframe.html',
	'text!./templates/error.html'
], function(ContentView, dot, $, StringResources, viewTemplate, errorViewTemplate) {
	'use strict'; //NOSONAR: Meant to be strict

	const IFrameView = ContentView.extend({

		/**
		 * @classdesc class to render an IFrame
		 * @constructs
		 * @public
		 * @param {options}
		 *		options.url - url to be loaded in IFrame
		 *		options.title - label to be used in perspective switcher
		 */
		init: function(options) {
			$.extend(this, options);
			ContentView.inherited('init', this, arguments);
		},

		/**
		 * Renders IFrame
		 * @public
		 */
		render: function() {
			if (typeof this.url === 'string') {
				return this._render();
			} else {
				$.extend(this, this._getOptionsFromId(this.id));
				if (typeof this.url === 'string') {
					return this._render();
				} else {
					return this._injectiFrame(errorViewTemplate, { errorMessage: IFrameView.ERROR_MESSAGE });
				}
			}
		},

		setFocus: function() {
			ContentView.inherited('setFocus', this, arguments);
			this.trigger('change:state');
		},

		_render: function() {
			const urlSafeMap = { '/':'_','+':'-' };
			const regex = new RegExp( Object.keys(urlSafeMap).join('|\\'), 'g');
			const url = 'v1/perspectives/home/urls/' + btoa(this.url).replace(regex,function(match) {return urlSafeMap[match];});
			const ajaxOptions = {
				type: 'GET',
				url: url,
				contentType: 'application/json; charset=utf-8',
				dataType: 'json',
				skipErrorHandling: true
			};
			return this.glassContext.getCoreSvc('.Ajax').ajax(ajaxOptions).then(() => {
				return this._injectiFrame(viewTemplate, { genericIframe_url: this.url });
			}).catch(() => {
				return this._injectiFrame(errorViewTemplate, { errorMessage: IFrameView.ERROR_MESSAGE });
			});
		},

		_getOptionsFromId: function(id) {
			try {
				const plugin = this.glassContext.appController.findElement(id);
				return plugin.options;
			} catch (e) {
				return null;
			}
		},

		_injectiFrame: function(template, context) {
			$.extend(context,{ 'genericIframe_title': this.getTitle() });
			const sHtml = dot.template(template)(context);
			this.$el.append(sHtml);
			return Promise.resolve();
		},

		getContent: function() {
			return {
				id: btoa(this.url),
				url: this.url,
				title: this.getTitle()
			};
		},

		getType: function() {
			return 'generic_iframe';
		},

		/**
		 * Returns title, used for perspective switcher
		 * @public
		 * @returns {string} title
		 */
		getTitle: function() {
			return this.title || StringResources.get('website');
		},

		execute: function(context) {
			const content = context.glassContext.appController.currentAppView.currentContentView.getContent();
			content.perspective = this.getType();
			return content;
		}
	});

	IFrameView.ERROR_MESSAGE = StringResources.get('invalidURLSupplied');

	return IFrameView;
});
